/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.53.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AssetClass,
  CreateAssetClass,
  CreateAssetClass201,
  ForbiddenErrorResponse,
  GetAssetClassParams,
  GetAssetClassesParams,
  Id,
  PutAssetClass,
  PutAssetClass201,
  SetAssetClassName,
  UnauthorizedErrorResponse,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * Fetch asset classes if user in JWT is authorized to access it.
 * @summary Get asset classes
 */
export const getAssetClasses = (
  tenantId: Id,
  params: GetAssetClassesParams,
  signal?: AbortSignal
) => {
  return httpClient<AssetClass[]>({
    url: `/query-service/tenant/${tenantId}/asset-class-information/get-asset-classes`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssetClassesQueryKey = (
  tenantId?: Id,
  params?: GetAssetClassesParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "asset-class-information",
    "get-asset-classes",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssetClassesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetClasses>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetAssetClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClasses>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssetClassesQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetClasses>>> = ({
    signal,
  }) => getAssetClasses(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetClasses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssetClassesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssetClasses>>
>;
export type GetAssetClassesQueryError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export function useGetAssetClasses<
  TData = Awaited<ReturnType<typeof getAssetClasses>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetAssetClassesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClasses>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClasses>>,
          TError,
          Awaited<ReturnType<typeof getAssetClasses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetClasses<
  TData = Awaited<ReturnType<typeof getAssetClasses>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetAssetClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClasses>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClasses>>,
          TError,
          Awaited<ReturnType<typeof getAssetClasses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetClasses<
  TData = Awaited<ReturnType<typeof getAssetClasses>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetAssetClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClasses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get asset classes
 */

export function useGetAssetClasses<
  TData = Awaited<ReturnType<typeof getAssetClasses>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetAssetClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClasses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetClassesQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAssetClass = (
  assetClassId: Id,
  createAssetClass: CreateAssetClass,
  signal?: AbortSignal
) => {
  return httpClient<CreateAssetClass201 | void>({
    url: `/command-service/asset-class/aggregate/asset-class/${assetClassId}/create-asset-class`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createAssetClass,
    signal,
  });
};

export const getCreateAssetClassMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssetClass>>,
    TError,
    { assetClassId: Id; data: CreateAssetClass },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssetClass>>,
  TError,
  { assetClassId: Id; data: CreateAssetClass },
  TContext
> => {
  const mutationKey = ["createAssetClass"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssetClass>>,
    { assetClassId: Id; data: CreateAssetClass }
  > = (props) => {
    const { assetClassId, data } = props ?? {};

    return createAssetClass(assetClassId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssetClass>>
>;
export type CreateAssetClassMutationBody = CreateAssetClass;
export type CreateAssetClassMutationError = void | UnauthorizedErrorResponse;

export const useCreateAssetClass = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAssetClass>>,
      TError,
      { assetClassId: Id; data: CreateAssetClass },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAssetClass>>,
  TError,
  { assetClassId: Id; data: CreateAssetClass },
  TContext
> => {
  const mutationOptions = getCreateAssetClassMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getAssetClass = (
  tenantId: Id,
  params: GetAssetClassParams,
  signal?: AbortSignal
) => {
  return httpClient<AssetClass>({
    url: `/query-service/tenant/${tenantId}/asset-class-information/get-asset-class`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssetClassQueryKey = (
  tenantId?: Id,
  params?: GetAssetClassParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "asset-class-information",
    "get-asset-class",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssetClassQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetClass>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetClassParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetClass>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssetClassQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetClass>>> = ({
    signal,
  }) => getAssetClass(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetClass>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssetClassQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssetClass>>
>;
export type GetAssetClassQueryError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

export function useGetAssetClass<
  TData = Awaited<ReturnType<typeof getAssetClass>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetClassParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetClass>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClass>>,
          TError,
          Awaited<ReturnType<typeof getAssetClass>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetClass<
  TData = Awaited<ReturnType<typeof getAssetClass>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetClassParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetClass>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClass>>,
          TError,
          Awaited<ReturnType<typeof getAssetClass>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetClass<
  TData = Awaited<ReturnType<typeof getAssetClass>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetClassParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetClass>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAssetClass<
  TData = Awaited<ReturnType<typeof getAssetClass>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetClassParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetClass>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetClassQueryOptions(tenantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setAssetClassName = (
  assetClassId: Id,
  setAssetClassName: SetAssetClassName,
  signal?: AbortSignal
) => {
  return httpClient<AssetClass>({
    url: `/command-service/asset-class/aggregate/asset-class/${assetClassId}/set-asset-class-name`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setAssetClassName,
    signal,
  });
};

export const getSetAssetClassNameMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssetClassName>>,
    TError,
    { assetClassId: Id; data: SetAssetClassName },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssetClassName>>,
  TError,
  { assetClassId: Id; data: SetAssetClassName },
  TContext
> => {
  const mutationKey = ["setAssetClassName"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssetClassName>>,
    { assetClassId: Id; data: SetAssetClassName }
  > = (props) => {
    const { assetClassId, data } = props ?? {};

    return setAssetClassName(assetClassId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssetClassNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssetClassName>>
>;
export type SetAssetClassNameMutationBody = SetAssetClassName;
export type SetAssetClassNameMutationError = UnauthorizedErrorResponse;

export const useSetAssetClassName = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssetClassName>>,
      TError,
      { assetClassId: Id; data: SetAssetClassName },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setAssetClassName>>,
  TError,
  { assetClassId: Id; data: SetAssetClassName },
  TContext
> => {
  const mutationOptions = getSetAssetClassNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteAssetClass = (assetClassId: Id, signal?: AbortSignal) => {
  return httpClient<AssetClass>({
    url: `/command-service/asset-class/aggregate/asset-class/${assetClassId}/delete-asset-class`,
    method: "POST",
    signal,
  });
};

export const getDeleteAssetClassMutationOptions = <
  TError = UnauthorizedErrorResponse | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssetClass>>,
    TError,
    { assetClassId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssetClass>>,
  TError,
  { assetClassId: Id },
  TContext
> => {
  const mutationKey = ["deleteAssetClass"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssetClass>>,
    { assetClassId: Id }
  > = (props) => {
    const { assetClassId } = props ?? {};

    return deleteAssetClass(assetClassId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssetClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssetClass>>
>;

export type DeleteAssetClassMutationError = UnauthorizedErrorResponse | void;

export const useDeleteAssetClass = <
  TError = UnauthorizedErrorResponse | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAssetClass>>,
      TError,
      { assetClassId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssetClass>>,
  TError,
  { assetClassId: Id },
  TContext
> => {
  const mutationOptions = getDeleteAssetClassMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const putAssetClass = (
  assetClassId: Id,
  putAssetClass: PutAssetClass,
  signal?: AbortSignal
) => {
  return httpClient<PutAssetClass201 | void>({
    url: `/command-service/asset-class/aggregate/asset-class/${assetClassId}/put-asset-class`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: putAssetClass,
    signal,
  });
};

export const getPutAssetClassMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAssetClass>>,
    TError,
    { assetClassId: Id; data: PutAssetClass },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAssetClass>>,
  TError,
  { assetClassId: Id; data: PutAssetClass },
  TContext
> => {
  const mutationKey = ["putAssetClass"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAssetClass>>,
    { assetClassId: Id; data: PutAssetClass }
  > = (props) => {
    const { assetClassId, data } = props ?? {};

    return putAssetClass(assetClassId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAssetClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAssetClass>>
>;
export type PutAssetClassMutationBody = PutAssetClass;
export type PutAssetClassMutationError = void | UnauthorizedErrorResponse;

export const usePutAssetClass = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAssetClass>>,
      TError,
      { assetClassId: Id; data: PutAssetClass },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putAssetClass>>,
  TError,
  { assetClassId: Id; data: PutAssetClass },
  TContext
> => {
  const mutationOptions = getPutAssetClassMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
